package one.healthium.base.utils

import one.healthium.base.launcher.PlatformLauncher

object BundleUtils {
    fun getAppName(platformLauncher: PlatformLauncher): String {
        return appName(platformLauncher)
    }
    fun getAppVersion(platformLauncher: PlatformLauncher): String {
        val version = appVersion(platformLauncher)
        val build = appBuildNumber(platformLauncher)
        return "v.$version($build)"
    }
}

internal expect fun appName(platformLauncher: PlatformLauncher): String
internal expect fun appVersion(platformLauncher: PlatformLauncher): String
internal expect fun appBuildNumber(platformLauncher: PlatformLauncher): String